import React from 'react';
import SEO from '../Components/SEO';
import { buildBreadcrumbSchema, PAGE_SEO } from '../seoConfig';

const PrivacyPolicy = () => {
    return (
        <>
            <SEO
                title={PAGE_SEO.privacy.title}
                description={PAGE_SEO.privacy.description}
                path={PAGE_SEO.privacy.path}
                noindex={PAGE_SEO.privacy.noindex}
                structuredData={buildBreadcrumbSchema([
                    { name: 'Início', path: '/' },
                    { name: 'Privacidade & Cookies', path: '/privacidade' },
                ])}
            />
            <div className="bg-[#f8f9fc] min-h-screen pt-32 pb-24 font-sans">
                {/* Legal Hero */}
                <div className="max-w-4xl mx-auto px-6 mb-20">
                    <div className="inline-block px-4 py-1 mb-6 text-[10px] font-black uppercase tracking-[0.4em] text-[#cebc52] bg-[#cebc52]/5 border border-[#cebc52]/20 rounded-full">
                        Legal
                    </div>
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#121214] tracking-tight mb-6">
                        Política de <span style={{ color: '#cebc52' }}>Privacidade & Cookies</span>
                    </h1>
                    <div className="w-16 h-1 bg-[#cebc52] rounded-full"></div>
                    <p className="mt-6 text-[#7a86a3] text-lg leading-relaxed max-w-2xl">
                        A Auto João Pires valoriza a sua confiança. Este documento detalha como gerimos os seus dados com transparência, rigor e respeito.
                    </p>
                </div>

                {/* Main Content */}
                <div className="max-w-4xl mx-auto px-6">
                    <div className="space-y-16">
                        
                        {/* Section I */}
                        <section className="bg-white border-2 border-[#e1e5f0] rounded-3xl p-8 sm:p-12">
                            <h2 className="text-xl font-black text-[#121214] mb-6 flex items-center gap-3">
                                <span className="w-8 h-1 bg-[#cebc52] rounded-full"></span>
                                Compromisso de Privacidade
                            </h2>
                            
                            <div className="text-[#3d4a6b] leading-relaxed space-y-4 text-sm">
                                <p>
                                    A <strong className="text-[#121214] font-bold">Forte Hipótese Unipessoal Lda</strong>, pessoa coletiva n.º 519 349 784, assume a responsabilidade de proteger a integridade dos seus dados pessoais em total conformidade com o RGPD.
                                </p>
                                <ul className="space-y-3 mt-4">
                                    {[
                                        "Minimização de Dados: Coletamos apenas o estritamente necessário.",
                                        "Transparência Total: Informamos claramente como e porquê usamos os seus dados.",
                                        "Segurança de Elite: Implementamos as melhores práticas para evitar acessos indevidos.",
                                        "Direitos do Utilizador: Garantimos o seu poder total sobre a sua informação."
                                    ].map((item, idx) => (
                                        <li key={idx} className="flex gap-3 items-start">
                                            <div className="w-2 h-2 rounded-full bg-[#cebc52] mt-1.5 shrink-0"></div>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </section>

                        {/* Section II */}
                        <section className="bg-white border-2 border-[#e1e5f0] rounded-3xl p-8 sm:p-12">
                            <h2 className="text-xl font-black text-[#121214] mb-8 flex items-center gap-3">
                                <span className="w-8 h-1 bg-[#cebc52] rounded-full"></span>
                                Ecossistema de Cookies
                            </h2>

                            <div className="space-y-8">
                                <div className="bg-[#f8f9fc] p-6 rounded-2xl border border-[#e1e5f0]">
                                    <h3 className="text-base font-bold text-[#121214] mb-3">O que são Cookies?</h3>
                                    <p className="text-[#7a86a3] text-sm leading-relaxed">
                                        Cookies são pequenos identificadores digitais que permitem ao nosso servidor reconhecer o seu dispositivo. Servem exclusivamente para otimizar a sua experiência de navegação.
                                    </p>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {[
                                        { t: "Essenciais", d: "Indispensáveis para o funcionamento base do site e áreas seguras." },
                                        { t: "Analíticos", d: "Permitem-nos entender o fluxo de tráfego e melhorar a usabilidade." },
                                        { t: "Funcionais", d: "Guardam as suas escolhas para que não tenha de as repetir." },
                                        { t: "Publicidade", d: "Ajudam a mostrar-lhe viaturas que realmente lhe interessam." }
                                    ].map((item, idx) => (
                                        <div key={idx} className="p-6 border-2 border-[#e1e5f0] rounded-2xl hover:border-[#cebc52]/30 transition-colors">
                                            <h4 className="font-bold text-xs uppercase tracking-widest text-[#cebc52] mb-2">{item.t}</h4>
                                            <p className="text-sm text-[#7a86a3] leading-relaxed">{item.d}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        {/* Section III */}
                        <section className="bg-white border-2 border-[#e1e5f0] rounded-3xl p-8 sm:p-12">
                            <h2 className="text-xl font-black text-[#121214] mb-6 flex items-center gap-3">
                                <span className="w-8 h-1 bg-[#cebc52] rounded-full"></span>
                                O Seu Controlo
                            </h2>
                            <p className="text-[#7a86a3] text-sm mb-8 leading-relaxed">
                                Pode gerir ou desativar as cookies diretamente nas definições do seu navegador:
                            </p>
                            
                            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                                {["Chrome", "Safari", "Firefox", "Edge"].map((b) => (
                                    <a key={b} href="#" className="py-3.5 border-2 border-[#e1e5f0] rounded-xl text-center text-xs font-bold uppercase tracking-wider text-[#3d4a6b] hover:bg-[#121214] hover:text-white hover:border-[#121214] transition-all">{b}</a>
                                ))}
                            </div>
                        </section>

                        <div className="text-center text-[#b0b9cc] text-xs font-semibold">
                            Última Atualização: Abril 2026
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
